import { NgModule } from "@angular/core";
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@fuse/material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FusePipesModule } from 'app/core/pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnswerCategoryQuestionComponent } from "./answer-category-question.component";
import { BarRatingModule } from 'ngx-bar-rating';
import { FuseSidebarModule } from '@fuse/components';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@NgModule({
    declarations: [
        AnswerCategoryQuestionComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FlexLayoutModule,
        FusePipesModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        FuseSidebarModule,
        NgxMatSelectSearchModule,
        BarRatingModule
    ],
    entryComponents: [
        AnswerCategoryQuestionComponent
    ],
    exports: [
        AnswerCategoryQuestionComponent
    ]
})

export class AnswerCategoryQuestionModule {

}